import { render, staticRenderFns } from "./UserDevicesList.vue?vue&type=template&id=79ae2c4c&scoped=true&"
import script from "./UserDevicesList.vue?vue&type=script&lang=js&"
export * from "./UserDevicesList.vue?vue&type=script&lang=js&"
import style0 from "./UserDevicesList.vue?vue&type=style&index=0&id=79ae2c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae2c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VChip,VCol,VDataTable,VPagination,VRow,VSelect,VTextField})
